import { useEffect, useState } from 'react';

type Message =
  | { from: 'user'; text: string }
  | { from: 'assistant'; text: string }
  | { from: 'order' };

const SCRIPT: Message[] = [
  { from: 'user', text: 'Pedime lo de siempre para el jueves, pero con el doble de tomate.' },
  { from: 'assistant', text: 'Listo, armé el pedido con tus precios. ¿Lo confirmo?' },
  { from: 'order' },
  { from: 'user', text: 'Dale, confirmalo.' },
  { from: 'assistant', text: 'Hecho: pedido #48213, llega el jueves de 8 a 12. 🍅' },
];

const ORDER_LINES = [
  ['Tomate redondo', '10 kg', '$18.900'],
  ['Lechuga criolla', '6 u', '$7.200'],
  ['Cebolla', '5 kg', '$4.750'],
  ['Limón', '3 kg', '$5.400'],
];

/**
 * A looping, made-up conversation that shows the flow: ask in plain words,
 * get a priced summary, confirm. Shows everything at once on the server and
 * for visitors who prefer reduced motion.
 */
export function ChatDemo() {
  const [visible, setVisible] = useState(SCRIPT.length);

  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    setVisible(0);
    let step = 0;
    const timer = window.setInterval(() => {
      step = step >= SCRIPT.length + 2 ? 0 : step + 1;
      setVisible(Math.min(step, SCRIPT.length));
    }, 1600);

    return () => window.clearInterval(timer);
  }, []);

  return (
    <div className="w-full max-w-md rounded-3xl border border-white/10 bg-white/5 p-4 shadow-2xl backdrop-blur-md">
      <div className="mb-3 flex items-center gap-2 border-b border-white/10 pb-3">
        <span className="h-3 w-3 rounded-full bg-red-400/80" />
        <span className="h-3 w-3 rounded-full bg-yellow-400/80" />
        <span className="h-3 w-3 rounded-full bg-green-400/80" />
        <span className="ml-2 text-xs font-medium text-white/60">Tu asistente + Abasto Virtual</span>
      </div>

      <div className="flex min-h-[360px] flex-col gap-3">
        {SCRIPT.slice(0, visible).map((message, index) => {
          if (message.from === 'order') {
            return (
              <div key={index} className="animate-modal-slide-in rounded-2xl bg-white p-4 text-sm text-gray-800 shadow-lg">
                <div className="mb-2 flex items-center justify-between">
                  <span className="font-bold">Pedido preparado</span>
                  <span className="rounded-full bg-green-100 px-2 py-0.5 text-xs font-semibold text-green-800">Jueves 8 a 12</span>
                </div>
                <ul className="space-y-1">
                  {ORDER_LINES.map(([product, quantity, price]) => (
                    <li key={product} className="flex justify-between gap-2">
                      <span>{product} <span className="text-gray-400">· {quantity}</span></span>
                      <span className="tabular-nums">{price}</span>
                    </li>
                  ))}
                </ul>
                <div className="mt-2 flex justify-between border-t border-gray-100 pt-2 font-bold">
                  <span>Total estimado</span>
                  <span className="tabular-nums">$36.250</span>
                </div>
              </div>
            );
          }

          const isUser = message.from === 'user';

          return (
            <div key={index} className={`flex animate-fade-in ${isUser ? 'justify-end' : 'justify-start'}`}>
              <p
                className={`max-w-[85%] rounded-2xl px-4 py-2 text-sm leading-relaxed ${
                  isUser ? 'rounded-br-sm bg-[#1EAA25] text-white' : 'rounded-bl-sm bg-white/15 text-white'
                }`}
              >
                {message.text}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
